import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_origin1s47cvkxjaphr as get_origin } from './URLBuilder.web.mjs';
import {
  Urlowwyg1lanrqp as Url,
  appendUrlFullPath2slafmfwiwvmw as appendUrlFullPath,
  appendUserAndPassword2m6va0hoftk5 as appendUserAndPassword,
} from './URLUtils.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Companion_getInstance25cbdbruarm2m as Companion_getInstance } from './Parameters.mjs';
import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  encodeURLQueryComponent1fjq9wb8rn8hq as encodeURLQueryComponent,
  encodeURLPathPart6y0hlser8v0t as encodeURLPathPart,
  decodeURLPart53igalrwb9si as decodeURLPart,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  encodeParameters1kx5voquz3xxo as encodeParameters,
  UrlDecodedParametersBuilder18hwlye3pykgz as UrlDecodedParametersBuilder,
} from './UrlDecodedParametersBuilder.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstanceudl2ftapa8hy as Companion_getInstance_0 } from './URLProtocol.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Url1652zsz51o0h6 as Url_0 } from './Url.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  startsWith1bgirhbedtv2y as startsWith,
  split3d3yeauc4rm2n as split,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  toMutableList20rdgwi7d3cwi as toMutableList,
  first58ocm7j58k3q as first,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_ROOT_PATH1cfc0dxvljm6a as get_ROOT_PATH } from './URLParser.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function applyOrigin($this) {
  var tmp;
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = $this.z57_1;
  if (charSequenceLength(this_0) > 0) {
    tmp = true;
  } else {
    tmp = $this.l58().j58_1 === 'file';
  }
  if (tmp)
    return Unit_instance;
  $this.z57_1 = Companion_getInstance_1().f59_1.m58_1;
  if ($this.c58_1 == null)
    $this.c58_1 = Companion_getInstance_1().f59_1.x58_1;
  if ($this.b58_1 === 0) {
    $this.h59(Companion_getInstance_1().f59_1.n58_1);
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.f59_1 = Url(get_origin(this));
        this.g59_1 = 256;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var URLBuilderClass;
function URLBuilder() {
  if (URLBuilderClass === VOID) {
    class $ {
      constructor(protocol, host, port, user, password, pathSegments, parameters, fragment, trailingQuery) {
        Companion_getInstance_1();
        protocol = protocol === VOID ? null : protocol;
        host = host === VOID ? '' : host;
        port = port === VOID ? 0 : port;
        user = user === VOID ? null : user;
        password = password === VOID ? null : password;
        pathSegments = pathSegments === VOID ? emptyList() : pathSegments;
        parameters = parameters === VOID ? Companion_getInstance().w57_1 : parameters;
        fragment = fragment === VOID ? '' : fragment;
        trailingQuery = trailingQuery === VOID ? false : trailingQuery;
        this.z57_1 = host;
        this.a58_1 = trailingQuery;
        this.b58_1 = port;
        this.c58_1 = protocol;
        var tmp = this;
        tmp.d58_1 = user == null ? null : encodeURLParameter(user);
        var tmp_0 = this;
        tmp_0.e58_1 = password == null ? null : encodeURLParameter(password);
        this.f58_1 = encodeURLQueryComponent(fragment);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().i2(collectionSizeOrDefault(pathSegments, 10));
        var _iterator__ex2g4s = pathSegments.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = encodeURLPathPart(item);
          destination.j2(tmp$ret$2);
        }
        tmp_1.g58_1 = destination;
        this.h58_1 = encodeParameters(parameters);
        this.i58_1 = new (UrlDecodedParametersBuilder())(this.h58_1);
      }
      h59(value) {
        // Inline function 'kotlin.require' call
        if (!(0 <= value ? value <= 65535 : false)) {
          var message = 'Port must be between 0 and 65535, or 0 if not set. Provided: ' + value;
          throw IllegalArgumentException().o2(toString(message));
        }
        this.b58_1 = value;
      }
      i59(value) {
        this.c58_1 = value;
      }
      l58() {
        var tmp0_elvis_lhs = this.c58_1;
        return tmp0_elvis_lhs == null ? Companion_getInstance_0().j59_1 : tmp0_elvis_lhs;
      }
      p59(value) {
        var tmp = this;
        tmp.d58_1 = value == null ? null : encodeURLParameter(value);
      }
      q59() {
        var tmp0_safe_receiver = this.d58_1;
        return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
      }
      r59() {
        var tmp0_safe_receiver = this.e58_1;
        return tmp0_safe_receiver == null ? null : decodeURLPart(tmp0_safe_receiver);
      }
      s59() {
        return decodeURLQueryComponent(this.f58_1);
      }
      t59() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.g58_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().i2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = decodeURLPart(item);
          destination.j2(tmp$ret$2);
        }
        return destination;
      }
      u59(value) {
        this.h58_1 = value;
        this.i58_1 = new (UrlDecodedParametersBuilder())(value);
      }
      v59() {
        applyOrigin(this);
        return appendTo(this, StringBuilder().vb(256)).toString();
      }
      toString() {
        return appendTo(this, StringBuilder().vb(256)).toString();
      }
      v39() {
        applyOrigin(this);
        return new (Url_0())(this.c58_1, this.z57_1, this.b58_1, this.t59(), this.i58_1.v39(), this.s59(), this.q59(), this.r59(), this.a58_1, this.v59());
      }
    }
    initMetadataForClass($, 'URLBuilder', URLBuilder);
    URLBuilderClass = $;
  }
  return URLBuilderClass;
}
function get_authority(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  this_0.m1(get_encodedUserAndPassword(_this__u8e3s4));
  this_0.m1(_this__u8e3s4.z57_1);
  if (!(_this__u8e3s4.b58_1 === 0) && !(_this__u8e3s4.b58_1 === _this__u8e3s4.l58().k58_1)) {
    this_0.m1(':');
    this_0.m1(_this__u8e3s4.b58_1.toString());
  }
  return this_0.toString();
}
function appendTo(_this__u8e3s4, out) {
  out.x1(_this__u8e3s4.l58().j58_1);
  switch (_this__u8e3s4.l58().j58_1) {
    case 'file':
      appendFile(out, _this__u8e3s4.z57_1, get_encodedPath(_this__u8e3s4));
      appendUrlFullPath(out, '', _this__u8e3s4.h58_1, _this__u8e3s4.a58_1);
      break;
    case 'mailto':
      appendMailto(out, get_encodedUserAndPassword(_this__u8e3s4), _this__u8e3s4.z57_1);
      return out;
    case 'about':
      appendPayload(out, _this__u8e3s4.z57_1);
      return out;
    case 'tel':
      appendPayload(out, _this__u8e3s4.z57_1);
      return out;
    case 'data':
      appendPayload(out, _this__u8e3s4.z57_1);
      return out;
    default:
      out.x1('://');
      out.x1(get_authority(_this__u8e3s4));
      appendUrlFullPath(out, get_encodedPath(_this__u8e3s4), _this__u8e3s4.h58_1, _this__u8e3s4.a58_1);
      break;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = _this__u8e3s4.f58_1;
  if (charSequenceLength(this_0) > 0) {
    out.o1(_Char___init__impl__6a9atx(35));
    out.x1(_this__u8e3s4.f58_1);
  }
  return out;
}
function get_encodedUserAndPassword(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  appendUserAndPassword(this_0, _this__u8e3s4.d58_1, _this__u8e3s4.e58_1);
  return this_0.toString();
}
function appendFile(_this__u8e3s4, host, encodedPath) {
  _this__u8e3s4.x1('://');
  _this__u8e3s4.x1(host);
  if (!startsWith(encodedPath, _Char___init__impl__6a9atx(47))) {
    _this__u8e3s4.o1(_Char___init__impl__6a9atx(47));
  }
  _this__u8e3s4.x1(encodedPath);
}
function set_encodedPath(_this__u8e3s4, value) {
  _this__u8e3s4.g58_1 = isBlank(value) ? emptyList() : value === '/' ? get_ROOT_PATH() : toMutableList(split(value, charArrayOf([_Char___init__impl__6a9atx(47)])));
}
function get_encodedPath(_this__u8e3s4) {
  return joinPath(_this__u8e3s4.g58_1);
}
function appendMailto(_this__u8e3s4, encodedUser, host) {
  _this__u8e3s4.x1(':');
  _this__u8e3s4.x1(encodedUser);
  _this__u8e3s4.x1(host);
}
function appendPayload(_this__u8e3s4, host) {
  _this__u8e3s4.x1(':');
  _this__u8e3s4.x1(host);
}
function joinPath(_this__u8e3s4) {
  if (_this__u8e3s4.n1())
    return '';
  if (_this__u8e3s4.q2() === 1) {
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = first(_this__u8e3s4);
    if (charSequenceLength(this_0) === 0)
      return '/';
    return first(_this__u8e3s4);
  }
  return joinToString(_this__u8e3s4, '/');
}
//region block: exports
export {
  URLBuilder as URLBuilder2mz8zkz4u9ray,
  get_authority as get_authorityakhc3pgcrb9j,
  set_encodedPath as set_encodedPath3q0i8nsv3a7qy,
};
//endregion

//# sourceMappingURL=URLBuilder.mjs.map
